"use client";
import{b as o,c as e}from"./chunk-PTYIHLHQ.js";import{useEffect as n}from"react";var r=!1;function f({shouldMount:t}){return n(()=>(t&&r&&o(),r=!0,()=>{e()}),[]),null}export{f as UnmountController};
